<app-filter-result-box>
    <!-- Keyword field -->
    @if (shownFilters.includes('name') && tableController) {
        <input
            (keyup)="tableController?.filter$.next(true)"
            [(ngModel)]="tableController.filter.data.keyword"
            placeholder="{{ 'translate_search_by_name' | translate }}"
            type="text"
        />
    }

    <!-- Tags -->
    @if (shownFilters.includes('tag') && tableController) {
        <ng-select
            (change)="tableController.filter$.next(true)"
            [(ngModel)]="tableController.filter.data.tagIds"
            [items]="tags"
            [multiple]="true"
            appClearSearchOnSelect
            bindLabel="name"
            bindValue="id"
            placeholder="{{ 'translate_tags' | translate }}"
        >
        </ng-select>
    }

    <!-- File types -->
    @if (tableController) {
        <ng-select
            (change)="tableController.filter$.next(true)"
            [(ngModel)]="tableController.filter.data.contentTypes"
            [items]="contentTypes"
            [multiple]="true"
            appClearSearchOnSelect
            bindLabel="name"
            bindValue="id"
            placeholder="{{ 'translate_file_type' | translate }}"
        >
            <ng-template ng-option-tmp let-item="item">
                <div class="flex items-center gap-4">
                    <app-file-icon
                        [icon]="item.name | lowercase"
                    ></app-file-icon>
                    <span>{{ item.name }}</span>
                </div>
            </ng-template>
        </ng-select>
    }

    <!-- Owner Ids -->
    @if (tableController) {
        <ng-select
            [items]="users"
            bindValue="id"
            bindLabel="name"
            [multiple]="true"
            appClearSearchOnSelect
            placeholder="{{ 'translate_users' | translate }}"
            [(ngModel)]="tableController.filter.data.ownerIds"
            (change)="tableController.filter$.next(true)"
        >
        </ng-select>
    }

    <!-- Only my files filter -->
    @if (shownFilters.includes('is_owner') && tableController) {
        <app-toggle-switch
            [(ngModel)]="tableController.filter.data.onlyMyFiles"
            (valueChange)="tableController.filter$.next(true)"
            [label]="'translate_only_my_files' | translate"
        ></app-toggle-switch>
    }
</app-filter-result-box>

<app-list-loading [items]="tableController.items">
    <app-library-file-list
        [tableController]="tableController"
        (tagClick)="filterByTag($event.id)"
    ></app-library-file-list>
    <app-table-pagination
        [tableController]="tableController"
    ></app-table-pagination>
</app-list-loading>
